module.exports = __webpack_public_path__ + "img/g-spline.da47266d.svg";